import { ColorEnum } from '@/constants/color'
import { ButtonStateEnum } from '@/features/ui/buttons/constants'
import { hexToRgba } from '@/utils/hexToRgba'

export const mainColors = {
    [ButtonStateEnum.Default]: {
        primary: ColorEnum.BRICK_600,
        secondary: ColorEnum.BLUE_500,
        action: ColorEnum.EMERALD_500,
        neutral: ColorEnum.WHITE,
    },
    [ButtonStateEnum.Hovered]: {
        primary: ColorEnum.BRICK_700,
        secondary: ColorEnum.Blue600,
        action: ColorEnum.Emerald600,
        neutral: ColorEnum.GRAY_200,
    },
    [ButtonStateEnum.Pressed]: {
        primary: ColorEnum.BRICK_700,
        secondary: ColorEnum.Blue600,
        action: ColorEnum.Emerald600,
        neutral: ColorEnum.GRAY_400,
    },
    [ButtonStateEnum.Disabled]: {
        primary: ColorEnum.BRICK_200,
        secondary: ColorEnum.Blue200,
        action: ColorEnum.EMERALD_200,
        neutral: ColorEnum.GRAY_300,
    },
} as const

export const outlineInteractiveBackgroundColors = {
    primary: ColorEnum.Brick300,
    secondary: ColorEnum.Blue100,
    action: ColorEnum.EMERALD_100,
    neutral: hexToRgba(ColorEnum.GRAY_100, 0.2),
} as const

export const nakedInteractiveBackgroundColors = {
    primary: ColorEnum.BRICK_200,
    secondary: ColorEnum.Blue100,
    action: ColorEnum.EMERALD_100,
    neutral: hexToRgba(ColorEnum.GRAY_100, 0.1),
} as const

export const shadowColors = {
    primary: ColorEnum.BRICK_600,
    secondary: ColorEnum.Blue600,
    action: ColorEnum.Emerald600,
    neutral: hexToRgba(ColorEnum.Gray250, 0.3),
} as const
